import ApiURL from "../apis/ApiURL";
import GeneralService from "../apis/GeneralService";
import Swal from 'sweetalert2';

export const getSelectedDevice = () => {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem('selectedDevice') || '';
};

const gameLunchHandler = (gameData, languageCode, token, playMode, useCommonCallback = false) => {

  return new Promise((resolve) => {
    const params = JSON.stringify({
      game_code: gameData.game_code,
      language: languageCode,
      game_mode: playMode,
      device: getSelectedDevice()
    });

    if (!token) {
      Swal.fire({
        icon: 'error',
        title: 'Launch Failed',
        text: 'Please Login to play',
      });
      resolve();
    } else {
      const isSpecialProvider = ['Evolution', 'Red Tiger', 'NetEnt', 'Big Time Gaming', 'Nolimit City - 94', 'Nolimit City - 96', 'Tap-A-Roo', 'Nolimit City - 92', 'Nolimit City'].includes(gameData.provider_name);
      // Use common callback (REACT_APP_CLIENT_API_BASE_URL) when toggle is enabled
      const apiCall = useCommonCallback ? GeneralService.apiPostCallRequest : (isSpecialProvider ? GeneralService.evoApiPostCallRequest : GeneralService.apiPostCallRequest);
      apiCall(ApiURL.getGameURL, params, token).then(res => {
        const url = res?.entry || res?.entryEmbedded || res?.data?.url;
        if (url && typeof url === 'string' && url !== 'undefined') {
          window.open(url, "_blank", "noreferrer");
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Launch Failed',
            text: 'Unable to launch the game',
          });
        }
        resolve();
      }).catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Launch Failed',
          text: error.message,
        });
        resolve();
      });
    }
  });
};

export default gameLunchHandler;
